import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { f as focusOutline } from '../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as Icon } from '../Icon/Icon-CpzUnHit.js';

const Header = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-ttofv1-0"
})(["background:", ";border-bottom:1px solid ", ";box-sizing:border-box;padding:1px;position:fixed;top:0;width:100%;z-index:1;"], ({
  theme
}) => theme.secondaryView.header.bg, ({
  theme
}) => theme.secondaryView.header.border.color);
Header.displayName = 'Header';
const Content = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-ttofv1-1"
})(["margin-top:51px;overflow-x:auto;padding:", ";height:100%;", ""], ({
  padding,
  theme
}) => theme.spacing[padding], isMobile(css(["padding:", ";"], ({
  padding,
  theme
}) => theme.mobile.spacing[padding])));
Content.displayName = 'Content';
const CloseButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    $focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30060407__sc-ttofv1-2"
})(["", ";border:none;background:transparent;color:", ";font-weight:bold;overflow:hidden;padding:14px 14px;text-align:start;text-overflow:ellipsis;white-space:nowrap;width:100%;margin-top:0;margin-bottom:0;:focus{outline:none;", " outline-offset:-1px;", "}:hover{color:", ";cursor:pointer;}", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.secondaryView.closeButton.color, ({
  $focusVisible
}) => $focusVisible && focusOutline, isMobile(css(["outline:none;box-shadow:none;"])), ({
  theme
}) => theme.secondaryView.closeButton.color, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.typography.mobile.size.base)));
CloseButton.displayName = 'CloseButton';
const CloseButtonIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30060407__sc-ttofv1-3"
})(["color:", ";margin-inline-end:", ";"], ({
  theme
}) => theme.secondaryView.closeIcon.color, ({
  theme
}) => theme.spacing.mini);
CloseButtonIcon.displayName = 'CloseButtonIcon';
const Shroud = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-ttofv1-4"
})(["background-color:", ";position:fixed;top:0;right:auto;bottom:auto;left:0;height:100vh;width:100vw;display:flex;align-items:center;justify-content:center;@media (prefers-reduced-motion:no-preference){transition:opacity 150ms ease-in-out;}opacity:", ";z-index:", ";"], ({
  theme
}) => theme.secondaryView.bg, ({
  $transitionState
}) => {
  if ($transitionState === 'entered') {
    return 1;
  }
  return 0;
}, ({
  theme
}) => theme.modal.zIndex);
Shroud.displayName = 'Shroud';

export { CloseButton as C, Header as H, Shroud as S, CloseButtonIcon as a, Content as b };
//# sourceMappingURL=SecondaryView.styles-D2OUIjsH.js.map
